import { render, staticRenderFns } from "./TBA_purchase.vue?vue&type=template&id=78fde6b1&"
import script from "./TBA_purchase.vue?vue&type=script&lang=js&"
export * from "./TBA_purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports